<template>
  <a-form :label-col="labelCol" :wrapper-col="wrapperCol" :model="formPerson">
    <a-row>
      <a-col :span="8">
        <a-form-item label="姓名：" name="name">
          <InputExtends
            v-model:input-val="formPerson.names"
            @ok="
              val => {
                sure(val, 'names')
              }
            "
          ></InputExtends>
          <!-- <a-input
            placeholder="请输入"
            v-model:value="formPerson.name"
            style="width: 100%"
            allowClear
            autocomplete="off"
            @change="handleChange"
          /> -->
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="邮箱：" name="email">
          <!-- <a-input
            placeholder="请输入"
            v-model:value="formPerson.emails"
            style="width: 100%"
            autocomplete="off"
            allowClear
            @change="handleChange"
          /> -->
          <InputExtends
            v-model:input-val="formPerson.emails"
            @ok="
              val => {
                sure(val, 'emails')
              }
            "
          ></InputExtends>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="职位信息：" name="title">
          <a-input
            placeholder="请输入"
            v-model:value="formPerson.title"
            style="width: 100%"
            autocomplete="off"
            allowClear
            @change="handleChange"
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item style="width: 100%" label="角色：" name="roleId">
          <a-select
            v-model:value="formPerson.roleId"
            allowClear
            placeholder="请选择"
            @change="handleChange"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, key) in roles"
              :key="key"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="8"></a-col>
      <a-col :span="8">
        <div style="margin-top:4px" class="tar seach-btn">
          <a-button class="ml10 mr10" @click="initData">查询</a-button>
          <AssignAuth :systems="data.selectOptions" text="批量分配" />
        </div>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import { inject, onMounted, reactive, toRefs, watch } from 'vue'
import AssignAuth from './AssignAuth'
import { common_info_get } from 'server/modules/351.js'
import InputExtends from 'components/ui/inputExtends.vue'
export default {
  components: { AssignAuth, InputExtends },
  setup() {
    const state = inject('state')
    const data = reactive({
      selectOptions: {}
    })
    const sure = (val, name) => {
      state.formPerson[name] = val
      state.initData()
    }
    const handleChange = () => {
      state.tablePagination.current = 1
    }
    function fetchBase() {
      common_info_get()
        .then(res => {
          data.selectOptions = res.data
        })
        .catch(() => {})
    }
    onMounted(() => {})
    fetchBase()
    watch(
      () => state.formPerson.name,
      () => {
        state.initData()
      }
    )
    return {
      handleChange,
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      ...toRefs(state),
      data,
      sure
    }
  }
}
</script>

<style lang="sass" scoped>
.seach-btn
  display: flex
  justify-content: flex-end
</style>
